import { Container, Tabs, Tab } from "react-bootstrap";
import ImpostazioniComune from "./ImpostazioniComune";
import AttivazioneModuli from "./AttivazioneModuli";
import ImpostazioniModuli from "./ImpostazioniModuli";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import PaginaNonTrovata from "../../Utente/Error/PaginaNonTrovata";
import { RiVipCrownFill } from "react-icons/ri";

export default function ImpostazioniGenerali(props) {

    // Hook di React Router per la navigazione e la gestione della posizione dell'URL
    const navigate = useNavigate();
    const location = useLocation();

    /**
     * Funzione per la gestione del cambio tab nelle impostazioni.
     * - Cambia la tab attiva aggiornando lo stato in `props.setTabAttivaImpostazioni`.
     * - Aggiorna l'URL con l'ancora corrispondente per mantenere lo stato della selezione anche dopo il refresh.
     */
    const toggleTab = (ev) => {
        if (ev.target.dataset.rrUiEventKey === "impostazioni-comune") {
            props.setTabAttivaImpostazioni("impostazioni-comune")
            navigate("/admin/impostazioni-generali#impostazioni-comune")
        }
        if (ev.target.dataset.rrUiEventKey === "attivazione-moduli") {
            props.setTabAttivaImpostazioni("attivazione-moduli")
            navigate("/admin/impostazioni-generali#attivazione-moduli")
        }
        if (ev.target.dataset.rrUiEventKey === "impostazioni-moduli") {
            props.setTabAttivaImpostazioni("impostazioni-moduli")
            navigate("/admin/impostazioni-generali#impostazioni-moduli")
        }
    }

    /**
    * useEffect che imposta la tab attiva in base all'ancora presente nell'URL.
     * In questo modo, se l'utente ricarica la pagina, viene ripristinata la scheda corretta.
     */
    useEffect(() => {
        if (location.hash === "#impostazioni-comune") props.setTabAttivaImpostazioni("impostazioni-comune")
        if (location.hash === "#attivazione-moduli") props.setTabAttivaImpostazioni("attivazione-moduli")
        if (location.hash === "#impostazioni-moduli") props.setTabAttivaImpostazioni("impostazioni-moduli")
    }, [props, location])


    /**
    * Controlla se l'utente ha i permessi per accedere alla pagina:
     * - Deve avere un `parId` valido.
    * - Deve avere il ruolo di amministratore (`ruoFlAmministratore === true`).
    */
    if (props.partecipante.parId && props.partecipante.ruolo.ruoFlAmministratore) {

        return (
            <Container fluid="lg">
                <div className="d-flex justify-content-between">
                    <h1 className="title">Impostazioni generali</h1>
                </div>
                {/* Tabs per la gestione delle diverse impostazioni */} 
                <Tabs activeKey={props.tabAttivaImpostazioni} id="uncontrolled-tab-example" className="mb-3"
                    onClick={toggleTab}>
                        {/* Tab per le impostazioni del comune */}
                    <Tab eventKey="impostazioni-comune" title="Impostazioni comune">
                        <ImpostazioniComune
                            comune={props.comune}
                            setRicaricaComune={props.setRicaricaComune}
                        />
                    </Tab>
                    {/* Tab per la configurazione dei moduli attivi */}
                    <Tab eventKey="impostazioni-moduli" title="Impostazioni moduli">
                    <ImpostazioniModuli
                                comune={props.comune}
                                setRicaricaComune={props.setRicaricaComune}
                            />
                    </Tab>
                    {/* Tab per l'attivazione dei moduli, visibile solo ai super admin */}
                    {props.partecipante.ruolo.ruoFlSuperAdmin &&

                        <Tab eventKey="attivazione-moduli" title={<><RiVipCrownFill className="mb-1" /> Attivazione moduli</>}>
                            <AttivazioneModuli
                                comune={props.comune}
                                setRicaricaComune={props.setRicaricaComune}
                            />
                        </Tab>
                    }

                </Tabs>
            </Container >
        )
    } else {
        return (<PaginaNonTrovata />
        )
    }

}